<template>
  <div class="app-container">
    <transition-group name="el-zoom-in-center">
      <!-- 项目头部列表 -->
      <el-card v-show="showList" key="header" class="custom-card mb-20" shadow="never">
        <el-form inline>
          <el-form-item>
            <el-select v-model="listQuery.status" clearable="" class="filter-item" placeholder="请选择审核状态">
              <el-option
                v-for="item in auditStatus"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item>
            <cy-date-picker :start.sync="listQuery.startTime" :end.sync="listQuery.endTime" style="width: 300px;"/>
          </el-form-item>

          <el-button
            v-waves
            v-if="calcPermission(permition, 1)"
            round
            class="filter-item"
            type="primary"
            icon="el-icon-search"
            @click="handleFilter"
          >{{ $t('table.search') }}</el-button>
          <template v-if="list.length !== 0">
            <el-button
              v-waves
              :loading="downloadLoading"
              class="filter-item"
              type="primary"
              icon="el-icon-download"
              @click="handleDownload"
            >{{ $t('table.export') }}</el-button>
            <template v-if="selectRows.length">
              <el-button
                v-waves
                class="filter-item"
                type="primary"
                @click="handleSuccess(selectRows, 'success', true)"
              >{{ $t('审核通过') }}</el-button>
              <el-button
                v-waves
                class="filter-item"
                type="danger"
                @click="handleNoPass(selectRows, true)"
              >{{ $t('审核不通过') }}</el-button>
            </template>

          </template>
        </el-form>
      </el-card>
      <!-- 项目列表 -->
      <div v-show="showList" key="list" class="filter-container">
        <el-table
          v-loading="listLoading"
          :key="tableKey"
          :data="list"
          fit
          stripe
          highlight-current-row
          style="width: 100%;"
          @selection-change="handleSelectionChange"
        >
          <el-table-column
            :selectable="handleSelectable"
            reserve-selection
            type="selection"
            width="55"
          />
          <el-table-column :label="$t('table.id')" align="center" width="50px">
            <template slot-scope="scope">
              <span>{{ (scope.$index + 1) + ((listQuery.pageIndex - 1) * listQuery.pageSize) }}</span>
            </template>
          </el-table-column>
          <el-table-column :label="`用户名`" align="center" >
            <template slot-scope="scope">
              <span v-if="scope.row.UserName">{{ scope.row.UserName }}</span>
              <span v-else>--</span>
            </template>
          </el-table-column>
          <!-- <el-table-column :label="`提现方式`" align="center" >
            <template slot-scope="scope">
              <span v-if="scope.row.AccountType">{{ scope.row.AccountType === 'Wx' ? '微信' : (scope.row.AccountType === 'Bank'?'银行卡':'') }}</span>
              <span v-else>--</span>
            </template>
          </el-table-column> -->
          <el-table-column :label="`审核状态`" align="center" >
            <template slot-scope="scope">
              <span v-if="scope.row.StatusNo">{{ scope.row.StatusNo | filterStatusNo }}</span>
              <span v-else>--</span>
            </template>
          </el-table-column>
          <el-table-column :label="`备注`" align="center" >
            <template slot-scope="scope">
              <span v-if="scope.row.ReturnCoinMemo">{{ scope.row.ReturnCoinMemo }}</span>
              <span v-else>--</span>
            </template>
          </el-table-column>
          <el-table-column :label="`审核失败原因`" align="center" >
            <template slot-scope="scope">
              <span v-if="scope.row.Memo">{{ scope.row.Memo }}</span>
              <span v-else>--</span>
            </template>
          </el-table-column>
          <el-table-column :label="`提现金额(元)`" align="center" >
            <template slot-scope="scope">
              <span v-if="scope.row.Rmb">{{ scope.row.Rmb }}</span>
              <span v-else>--</span>
            </template>
          </el-table-column>
          <el-table-column :label="`提现状态`" align="center" >
            <template slot-scope="scope">
              <span v-if="scope.row.RetCoinStatus">{{ scope.row.RetCoinStatus | filterRetCoinStatus }}</span>
              <span v-else>--</span>
            </template>
          </el-table-column>

          <el-table-column :label="`提现失败信息`" align="center" >
            <template slot-scope="scope">
              <span v-if="scope.row.RetCoinMemo">{{ scope.row.RetCoinMemo }}</span>
              <span v-else>--</span>
            </template>
          </el-table-column>

          <el-table-column :label="`提现单号`" align="center" >
            <template slot-scope="scope">
              <span v-if="scope.row.PaymentNo">{{ scope.row.PaymentNo }}</span>
              <span v-else>--</span>
            </template>
          </el-table-column>
          <el-table-column :label="`提现手续费比例`" align="center" >
            <template slot-scope="scope">
              <span v-if="scope.row.Poundage">{{ scope.row.Poundage }}</span>
              <span v-else>0</span>
            </template>
          </el-table-column>
          <el-table-column :label="`实际到账金额`" align="center" >
            <template slot-scope="scope">
              <span v-if="scope.row.RealRmb">{{ scope.row.RealRmb }}</span>
              <span v-else>0</span>
            </template>
          </el-table-column>
          <el-table-column :label="`到账说明`" align="center" >
            <template slot-scope="scope">
              <span v-if="scope.row.RetCoinDetail">{{ scope.row.RetCoinDetail }}</span>
              <span v-else>--</span>
            </template>
          </el-table-column>

          <el-table-column :label="`提现完成时间`" align="center" width="200px" >
            <template slot-scope="scope">
              <span v-if="scope.row.PaymentTime">{{ scope.row.PaymentTime }}</span>
              <span v-else>--</span>
            </template>
          </el-table-column>

          <el-table-column :label="`添加时间`" align="center" width="200px" >
            <template slot-scope="scope">
              <span v-if="scope.row.AddTime">{{ scope.row.AddTime }}</span>
              <span v-else>--</span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('table.actions')" align="center" lass-name="small-padding fixed-width" width="160">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.StatusNo === 'AS' && calcPermission(permition, 1)" type="success">{{ `审核已通过` }}</el-tag>
              <el-tag v-else-if="scope.row.StatusNo === 'AF' && calcPermission(permition, 1)" type="danger">审核未通过</el-tag>
              <template v-else>
                <el-button v-if="calcPermission(permition, 1)" size="mini" type="primary" @click="handleSuccess(scope.row, 'success')">{{ `通过` }}</el-button>
                <el-button v-if="calcPermission(permition, 1)" size="mini" type="danger" @click="handleNoPass(scope.row)">{{ `不通过` }}</el-button>
                <!-- <el-button v-if="calcPermission(permition, 1)" size="mini" type="primary" @click="handleSuccess(scope.row, 'done')">{{ `已处理` }}</el-button> -->
              </template>
            </template>
          </el-table-column>
        </el-table>
        <el-card class="custom-card" shadow="never">
          <el-pagination v-show="total>0" :current-page="listQuery.pageIndex" :page-sizes="[10,20,50,100]" :page-size="listQuery.pageSize" :total="total" layout="total, prev, pager, next" @size-change="handleSizeChange" @current-change="handleCurrentChange"/>
        </el-card>
      </div>
    </transition-group>
  </div>
</template>

<script>
import { qryRoleInfo } from '@/api/baseModule'
import { qryReturnCoin, verifyPass, verifyNoPass, verifyDone } from '@/api/account'
import { exportExcel } from './api/withdraw'
import { parseTime } from '@/utils'
import waves from '@/directive/waves' // 水波纹指令
import CyDatePicker from '@/components/CyDatePicker'
export default {
  directives: {
    waves
  },
  components: { CyDatePicker },
  filters: {
    filterType(value) {
      let str = ''
      switch (value) {
        case 'profit':
          str = '收益'
          break
        case 'topUp':
          str = '充值'
          break
        case 'back':
          str = '返回'
          break
      }
      return str
    },
    filterRetCoinStatus(value) {
      let str = ''
      switch (value) {
        case 'SUCCESS':
          str = '成功'
          break
        case 'ERROR':
          str = '异常'
          break
        case 'PROCESSING':
          str = '处理中'
          break
        case 'FAILED':
          str = '失败'
          break
        case 'BANK_FAIL':
          str = '失败'
          break
      }
      return str
    },
    filterStatusNo(value) {
      let str = ''
      switch (value) {
        case 'AT':
          str = '审核中'
          break
        case 'AS':
          str = '审核成功'
          break
        case 'AF':
          str = '审核失败'
          break
      }
      return str
    }
  },
  data() {
    return {
      url_: process.env.BASE_API,
      listQuery: {
        pageIndex: 1,
        pageSize: 10,
        status: null,
        startTime: null,
        endTime: null
      },
      auditStatus: [
        {
          value: 'AT',
          label: '审核中'
        },
        {
          value: 'AS',
          label: '审核成功'
        },
        {
          value: 'AF',
          label: '审核失败'
        }
      ],
      list: [],
      showList: true,
      permition: 0,
      listLoading: true,
      tableKey: 0,
      total: null,
      bookType: 'xlsx',
      bookTypeList: ['xlsx', 'csv', 'txt'],
      downloadLoading: false,
      selectRows: []
    }
  },
  created() {
    if (this.$store.state.roleInfo) {
      this.$store.state.roleInfo.LsList[0].RolePrograms.forEach(item => {
        if (this.$route.path === item.ProgramInfo.PgUrl) {
          this.permition = item.Permition
          this.qryList()
        }
      })
      // this.$store.state.roleInfo.LsList.forEach(item => {
      //   item.RolePrograms.forEach(item => {
      //     if (this.$route.path === item.ProgramInfo.PgUrl) {
      //       this.permition = item.Permition
      //       this.qryList()
      //     }
      //   })
      // })
    } else {
      qryRoleInfo({
        rId: this.$store.getters.roles.RoleId
      }).then(response => {
        this.$store.state.roleInfo = response
        response.LsList[0].RolePrograms.forEach(item => {
          if (this.$route.path === item.ProgramInfo.PgUrl) {
            this.permition = item.Permition
            this.qryList()
          }
        })
      })
    }
  },
  methods: {
    handleSelectable(row, index) {
      console.log(row, index)
      return row.StatusNo !== 'AS'
    },
    handleSelectionChange(e) {
      console.log(e)
      this.selectRows = e
    },
    // 查询列表
    qryList() {
      qryReturnCoin(this.listQuery).then(response => {
        this.list = response.LsList
        this.total = response.TotalRows
        this.listLoading = false
        // this.resetTemp()
      })
    },
    // 重置查询数据
    resetTemp() {
      this.listQuery = {
        pageIndex: this.listQuery.pageIndex,
        pageSize: this.listQuery.pageSize,
        userName: null,
        time: null
      }
    },
    // 数据导出
    handleDownload() {
      this.downloadLoading = true
      exportExcel(this.listQuery).then(res => {
        if (res) {
          window.open(this.url_ + res)
          this.downloadLoading = false
        }
      }).finally(() => {
        this.downloadLoading = false
      })
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => {
        console.log(v)
        console.log(j)
        if (j === 'timestamp') {
          return parseTime(v[j])
        } else {
          return v[j]
        }
      }))
    },
    // 审核通过
    handleSuccess(row, type, checked) {
      this.listLoading = true
      if (type === 'success') {
        verifyPass({ coinId: checked ? this.selectRows.map(item => item.CoinId) : [row.CoinId] }).then(response => {
          if (response) {
            this.$message({
              message: '操作成功',
              type: 'success'
            })
            this.qryList()
          } else {
            setTimeout(() => {
              this.listLoading = false
            }, 2000)
          }
        })
      } else {
        verifyDone({ coinId: [row.CoinId] }).then(res => {
          if (res) {
            this.$message({
              message: '操作成功',
              type: 'success'
            })
            this.qryList()
          } else {
            setTimeout(() => {
              this.listLoading = false
            }, 2000)
          }
        })
      }
    },
    // 审核不通过
    handleNoPass(row, checked) {
      this.$prompt('请输入不通过原因', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /[^\x00-\xff]/,
        inputErrorMessage: '请输入原因（中文）'
      }).then(({ value }) => {
        this.listLoading = true
        verifyNoPass({ coinId: checked ? this.selectRows.map(item => item.CoinId) : [row.CoinId], content: value }).then(response => {
          if (response) {
            this.$message({
              message: '操作成功',
              type: 'success'
            })
            this.qryList()
          } else {
            setTimeout(() => {
              this.listLoading = false
            }, 2000)
          }
        })
      })
    },
    // 修改页容量重新查询列表
    handleSizeChange(val) {
      this.listQuery.pageSize = val
      this.qryList()
    },
    // 修改页码重新查询列表
    handleCurrentChange(val) {
      this.listQuery.pageIndex = val
      this.qryList()
    },
    handleFilter() {
      this.listQuery.pageIndex = 1
      this.qryList()
    }
  }
}
</script>

<style lang="sass" scoped>
</style>
